import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentValueConstraints on ValueConstraints {
    acceptable
    unacceptable
    pattern
    minLength
    maxLength
    max
    min
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentValueConstraintsFragment,
  ents.core.common.value.Constraints
>({
  acceptable: transformers.PASS_THROUGH,
  length: {
    usingFullInput: graphql.transformers.OUT.if<
      graphql.schema.FragmentValueConstraintsFragment,
      ents.core.common.value.Constraints['length']
    >(
      // If max length and min length are the same...
      input => input?.maxLength === input?.minLength,
      // Then length can just be that value (either number or undefined)
      graphql.transformers.OUT.select('maxLength', transformers.PASS_THROUGH),
      // Otherwise, we pull out both the max and min length
      graphql.transformers.OUT.object<
        graphql.schema.FragmentValueConstraintsFragment,
        Extract<ents.core.common.value.Constraints['length'], object>
      >({
        max: graphql.transformers.OUT.select(
          'maxLength',
          transformers.PASS_THROUGH,
        ),
        min: graphql.transformers.OUT.select(
          'minLength',
          transformers.PASS_THROUGH,
        ),
      }),
    ),
  },
  max: transformers.PASS_THROUGH,
  min: transformers.PASS_THROUGH,
  pattern: graphql.transformers.OUT.instance(RegExp, transformers.PASS_THROUGH),
  unacceptable: transformers.PASS_THROUGH,
})
